import React, { useEffect, useState } from "react";
import { Route, Redirect, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { useIntercom } from "react-use-intercom";
import ErrorBoundary from "./ErrorBoundary";

import { useDispatch } from "react-redux";
import { setUser } from "../app-store/userSlice";
import httpClient from "../custom-hooks/httpClient";
import TransactionPin from "./TransactionPin";
import NinUpdate from "./NinUpdate";

function ProtectedRoute({ component: Component, ...rest }) {
  const userToken = localStorage.getItem("tk");
  const userId = localStorage.getItem("id");
  const [transactionPinModal, setTransactionPinModal] = useState(false);
  const [showNinUpdate, setShowNinUpdate] = useState(false);

  const history = useHistory();

  const dispatch = useDispatch();

  const { boot } = useIntercom();

  useEffect(() => {
    httpClient
      .get(`/users/${userId}`)
      .then(({ status, data }) => {
        if (status === 200) {
          const { user } = data;
          dispatch(setUser(user));
          boot({
            name: `${user.first_name} ${user.last_name}`,
          });
          // Check if the user has enabled transaction pin.
          if (!user.isTransactionPinEnabled) {
            setTransactionPinModal(true);
          }
          // Check if user has updated NIN
          if (
            !user.nin &&
            (user.nin_verification_status === null ||
              user.nin_verification_status === "declined") &&
            !user.is_verified &&
            user.mifos_client_id
          ) {
            setShowNinUpdate(true);
          }
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error("Error getting user");
        history.push("/login");
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {transactionPinModal && (
        <TransactionPin onClose={() => setTransactionPinModal(false)} />
      )}
      {showNinUpdate ? (
        <NinUpdate onClose={() => setShowNinUpdate(false)} />
      ) : null}

      <Route
        {...rest}
        render={(props) => {
          if (userToken && userId) {
            return (
              <ErrorBoundary>
                <Component {...rest} {...props} />
              </ErrorBoundary>
            );
          } else {
            return <Redirect to="/login" />;
          }
        }}
      />
    </>
  );
}

export default ProtectedRoute;
